import Swiper, { Autoplay, FreeMode } from 'swiper';

export default class Awards {
  constructor() {
    this.selector = 'b-af-awards';

    this.selectors = {
      slider: 'b-af-awards__slider',
      slidesWrapper: 'b-af-awards__items',
      slide: 'b-af-awards__item',
    };

    this.blocks = Array.from(document.querySelectorAll(`.${this.selector}`));
    this.slides = Array.from(document.querySelectorAll(`.${this.selectors.slide}`));

    if (this.blocks.length === 0) return;

    this.init();
  }

  init() {
    this.blocks.forEach((block) => {
      this.initSwiper({ block });
    });
  }

  initSwiper({ block }) {
    const slider = block.querySelector(`.${this.selectors.slider}`);
    const awardPause = block.querySelector(`.${this.selectors.slidesWrapper}`).getAttribute('data-pause');
    const awardFreeMove = block.querySelector(`.${this.selectors.slidesWrapper}`).getAttribute('data-free-move');

    Swiper.use([Autoplay, FreeMode]);

    new Swiper(slider, {
      speed: 6000,
      touchStartPreventDefault: true,
      allowTouchMove: awardFreeMove,
      watchSlidesProgress: true,
      loopAdditionalSlides: 1,
      autoplay: {
        delay: 0,
        pauseOnMouseEnter: awardPause,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: 'auto',
      freeMode: {
        enabled: awardFreeMove,
        momentum: false,
        momentumBounce: false,
      },
      on: {
        touchStart: function() {
          this.autoplay.stop();
          this.params.speed = 300;
        },
        touchEnd: function() {
          this.params.speed = 6000;
          this.autoplay.start();
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/awards.js